"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchableReactSelect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _DropdownIndicator = _interopRequireDefault(require("./components/DropdownIndicator"));
var _utils = require("./utils");
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
require("./SearchableReactSelect.less");
var _excluded = ["form", "options", "name", "placeholder", "className", "onChange", "filterOption"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var SearchableReactSelect = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var form = _ref.form,
    options = _ref.options,
    fieldName = _ref.name,
    placeholder = _ref.placeholder,
    className = _ref.className,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange,
    _ref$filterOption = _ref.filterOption,
    filterOption = _ref$filterOption === void 0 ? _utils.filterOptions : _ref$filterOption,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasFocus = _useState4[0],
    setHasFocus = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasErrorOnBlur = _useState6[0],
    setHasErrorOnBlur = _useState6[1];
  var setFieldsValue = form.setFieldsValue,
    getFieldValue = form.getFieldValue,
    getFieldsError = form.getFieldsError,
    validateFields = form.validateFields;
  var selectedValue = getFieldValue(fieldName);
  var selectedOption = (0, _lodash.isArray)(selectedValue) ? (0, _lodash.filter)(options, function (option) {
    return selectedValue.includes(option.value);
  }) : (0, _lodash.find)(options, function (option) {
    return option.value === selectedValue;
  });
  var formValidationErrors = getFieldsError();
  var fieldValidationError = formValidationErrors[fieldName];
  var hasError = (0, _utils.hasSearchableSelectValidationError)({
    form: form,
    fieldName: fieldName,
    hasErrorOnBlur: hasErrorOnBlur
  });
  var handleOptionChange = function handleOptionChange(newValue, actionMeta) {
    if (actionMeta.action === 'select-option') {
      var _selectedValue = (0, _lodash.isArray)(newValue) ? newValue.map(function (_ref2) {
        var value = _ref2.value;
        return value;
      }) : newValue === null || newValue === void 0 ? void 0 : newValue.value;
      setFieldsValue(_defineProperty({}, fieldName, _selectedValue));
      setSearchValue('');
      setHasErrorOnBlur(false);
      onChange(_selectedValue);
    }
    if (actionMeta.action === 'clear') {
      setSearchValue('');
      setFieldsValue(_defineProperty({}, fieldName, undefined));
      setHasErrorOnBlur(false);
      onChange(undefined);
    }
  };
  var handleOptionsSearch = function handleOptionsSearch(newValue, actionMeta) {
    if (actionMeta.action === 'input-change') {
      setSearchValue(newValue);
    }
  };
  var handleFocus = function handleFocus() {
    return setHasFocus(true);
  };
  var handleBlur = function handleBlur() {
    setHasErrorOnBlur(!!fieldValidationError);
    setHasFocus(false);
    setSearchValue('');
  };
  (0, _react.useEffect)(function () {
    validateFields();
  }, []);

  // Removing props that are not needed above, so that we could use any other React Select props
  // That is especially important, to pass override styles, see https://react-select.com/styles
  var reactSelectProps = (0, _lodash.omit)(props, ['value', 'data-__field', 'data-__meta']);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactSelect.default, _extends({
    ref: ref,
    options: options,
    className: (0, _classnames.default)('searchable-react-select', {
      'error-state': hasError,
      'focus-state': hasFocus
    }, className),
    classNamePrefix: "searchable-select-inner",
    value: selectedOption,
    inputValue: hasFocus ? searchValue : undefined,
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.default
    },
    filterOption: _utils.filterOptions,
    placeholder: placeholder,
    onChange: handleOptionChange,
    onInputChange: handleOptionsSearch,
    onBlur: handleBlur,
    onFocus: handleFocus,
    blurInputOnSelect: false
  }, reactSelectProps)), hasError && /*#__PURE__*/_react.default.createElement("span", {
    className: "text-alertred-60 tw-caption-regular"
  }, fieldValidationError));
});
exports.SearchableReactSelect = SearchableReactSelect;